<template>
    <div id="app">
        <header v-if="$showTitle" id="header">
            <van-nav-bar :title="'北斗智保'">
                <template #left v-if="!$route.meta.noBack">
                    <van-icon
                        color="#1989fa"
                        :size="18"
                        name="arrow-left"
                        @click="onClickLeft"
                    />

                    <van-icon
                        v-if="!$route.meta.close"
                        color="#1989fa"
                        :size="18"
                        style="margin-left: .1rem;"
                        name="cross"
                        @click="onClickLink"
                    />
                </template>
            </van-nav-bar>
        </header>
        <section>
            <keep-alive>
                <router-view
                    class="clearfix"
                    :class="{ 'router-box': $showTitle }"
                    v-if="$route.meta.keepAlive"
                />
            </keep-alive>

            <router-view
                class="clearfix"
                :class="{ 'router-box': $showTitle }"
                v-if="!$route.meta.keepAlive"
            />
        </section>
    </div>
</template>

<script>
import share from "cignacmb-share";
import getPublicFileUrl from "@/utils/getPublicFileUrl.js";
export default {
    methods: {
        onClickLeft() {
            this.$router.go(-1);
        },
        onClickLink() {
            location.href = "https://m.cignacmb.com";
        },
    },
    created() {
        share(
            {
                title: "未来已来－－北斗AI帮您选保险",
                content: "年轻人,撬起杠杆,为温馨的家提供保障吧！",
                url: `${location.origin + location.pathname}`,
                image: getPublicFileUrl("/share-icon.png"),
            },
            { withGuide: false }
        );
    },
};
</script>

<style>
#app {
    width: 100vw;
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
}
.full-screen-loading .icon {
    right: 0.07rem !important;
}
</style>

<style scoped>
#header {
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 2;
}
#header.top {
    z-index: 9999;
}
section .router-box::before {
    clear: both;
    content: "";
    display: block;
    width: 100%;
    height: 46px;
}
</style>
